/*eslint-disable*/
import React, { useState, useTransition } from 'react';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Alert,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types'
import { toast } from 'react-toastify';


import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
// helpers
import { makeResetMultiFactorDTO } from './resetMultiFactor.helpers';

// services
import { resetMultiFactor,resetSpecifiedFactor } from '../../services/user';

// hooks
import useAuthenticatorEnrollments from './hooks/useAuthenticatorTypes';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

// styles
import styles from './resetMultiFactor.module.scss'

const renderContentTitle = () => <Typography sx={{ marginBottom: "10px" }}>
  {`${i18next.t('reset-multifactor-lable')}`}
</Typography>

const renderContent = ({
  areAuthenticatorEnrollmentsLoading, 
  authenticatorEnrollmentOptions,
  checkedFactors,
  handleCheckboxFactors
}) => {
  if(areAuthenticatorEnrollmentsLoading) {
    return (<CircularProgress sx={{ color: "black" }} />)
  }
  if(authenticatorEnrollmentOptions.length > 0) {
    return<>
    {renderContentTitle()}
    <b>
            {i18next.t('reset-multifactor-authentication-factors')}
    </b>

    <div style={{ display: 'flex', flexDirection: 'column' }}>
    {
      <FormControl component="fieldset">
      {/* <FormLabel component="legend">Choose an option</FormLabel> */}
      <RadioGroup aria-label="options" name="options" value={checkedFactors} onChange={handleCheckboxFactors}>
        {authenticatorEnrollmentOptions.map((option) => (
          <FormControlLabel
            key={option.factorId}
            value={option.factorId}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>

     }
    </div>

    </>
  }
  return <>
  {renderContentTitle()}
        <Alert
          severity="warning"
          style={{ margin: '10px 0px' }}
        >
          {`${i18next.t('reset-multifactor-not-set')}`}
        </Alert>
  </>
}
function ResetMultiFactor({ showModal, handleClose, userId }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedEnrollments, setSelectedEnrollments] = useState([])
  const [checkedFactors, setCheckedItems] = useState("");
  const { t } = useTranslation()

  const {
    authenticatorEnrollmentOptions,
    areAuthenticatorEnrollmentsLoading
  } = useAuthenticatorEnrollments(userId)

  const setAsSubmitted = () => setIsSubmitting(false);

  const handleResetMultiFactorSuccess = () => {
    toast.success(t('reset-multifactor-link-sent-successfully'))
    handleClose();
  };

  const handleResetMultiFactorFailure = (err) => {
    toast.error(err.message)
  };

  const handleResetMultiFactor = () => {
    const resetMultiFactorDTO = makeResetMultiFactorDTO();
    setIsSubmitting(true)
    resetSpecifiedFactor(checkedFactors,resetMultiFactorDTO, userId)
      .then(handleResetMultiFactorSuccess)
      .catch(handleResetMultiFactorFailure)
      .finally(setAsSubmitted);
  };

  const handleCheckboxClick = (e) => {
    const value = e.target.id;
    let updatedSelectedEnrollments = []
    if (selectedEnrollments.includes(value)) {
      updatedSelectedEnrollments = selectedEnrollments.filter(
        (selectedEnrollment) => !selectedEnrollments.includes(selectedEnrollment)
      );
    } else {
      updatedSelectedEnrollments = [...selectedEnrollments, value]
    }
    setSelectedEnrollments(updatedSelectedEnrollments)
  }

  const handleCheckboxFactors = (event) => {
    setCheckedItems(event.target.value);
  };

  const isButtonEnabled = Object.values(checkedFactors).some((checked) => checked);

  return (
    <Dialog open={showModal} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
      <DialogTitle className={styles.heading}>
        { t('reset-multifactor-title') }
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.iconBtn}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.container}>
          {renderContent({
            areAuthenticatorEnrollmentsLoading, 
            authenticatorEnrollmentOptions,
            checkedFactors,
            handleCheckboxFactors
            })}
      </DialogContent>
      {!areAuthenticatorEnrollmentsLoading &&
        <DialogActions className={styles.actions}>
          <Button
            onClick={handleClose}
            type="submit"
            className={styles.cancelBtn}
            variant="contained"
            disabled={isSubmitting}
            data-testid="resetMultiFactorCancel"
          >
            {t('reset-password-cancel')}
          </Button>
         {authenticatorEnrollmentOptions.length > 0 && <Button
            onClick={handleResetMultiFactor}
            type="submit"
            className={styles.continueBtn}
            variant="contained"
            disabled={!isButtonEnabled}
            data-testid="resetMultiFactorSubmit"
          >
            {t('reset-multifactor-reset-selected-factor')}
          </Button>}
        </DialogActions>}
    </Dialog>
  );
}

export default ResetMultiFactor;

ResetMultiFactor.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  userId: PropTypes.func.isRequired,
};
